module.exports = __webpack_public_path__ + "static/media/31JFA6.d9bfdb38.jpg";